module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-row-condition-approve"
    }
  }, [_c('label', {
    staticClass: "color-skin align-center"
  }, [_vm._v("Status Approve Condition")]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "indexDisp": true,
      "approveDisp": true,
      "approveBtnDisp": true,
      "approveEvent": _vm.approveEvent,
      "detailEvent": _vm.detailEvent,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin align-center"
  }, [_vm._v("Status Approve + Custom Condition")]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "indexDisp": true,
      "approveDisp": true,
      "approveBtnDisp": true,
      "approveEvent": _vm.approveEvent,
      "detailEvent": _vm.detailEvent,
      "nowLang": _vm.nowLang,
      "rowDisableCondition": _vm.rowDisableCondition
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df188bf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableRowConditionApprove.vue
// module id = 3995
// module chunks = 1